import React from 'react'
import styles from '../stylesheets/Footer.module.scss'
import { FaAngleDoubleUp, FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';

 const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
    return (
        <div className={styles.footer}>
            <div className={styles.links}>
                <a
                    href="#home"
                    className={styles.topLink}
                    >
                      
                    <FaAngleDoubleUp/>
                </a>
                <a href="https://github.com/arnelamo/">
                    <FaGithub
                        className={styles.social}
                    />
                </a>
                <a href="https://www.instagram.com/arnelamo/">
                    <FaInstagram
                        className={styles.social}
                    />
                </a>
                <a href="https://www.linkedin.com/in/arnelamopedersen/">
                    <FaLinkedin
                        className={styles.social}
                    />
                </a>
            </div>
            <div className={styles.copyright}>
              <span>ARNE PEDERSEN</span> <span className={styles.year}>© {year}</span>
            </div>
        </div>
    )
}

export default Footer